import { atomWithStorage } from 'jotai/utils'
import { ResolutionString } from 'public/charting_library/charting_library'

import { STORAGE_KEY } from '@/constants/common'
import { DEFAULT_RESOLUTIONS } from '@/constants/tradingiew'

export const intervalAtom = atomWithStorage<ResolutionString>(
  STORAGE_KEY.INTERVAL,
  DEFAULT_RESOLUTIONS,
  undefined,
  {
    getOnInit: true
  }
)
